import { ROUTES } from "../routes/registry";

export interface ManifestElement {
  key: string;
  label: string;
  group?: string;
}

export interface ManifestPage {
  pageKey: string;
  label: string;
  elements: ManifestElement[];
}

function buildManifest(): ManifestPage[] {
  const byKey = new Map<string, ManifestPage>();
  for (const r of ROUTES) {
    if (!r.pageKey) continue;
    const existing = byKey.get(r.pageKey);
    if (!existing) {
      byKey.set(r.pageKey, {
        pageKey: r.pageKey,
        label: r.pageLabel ?? r.pageKey,
        elements: r.elements ? [...r.elements] : [],
      });
    } else {
      if (r.pageLabel && existing.label === existing.pageKey) {
        existing.label = r.pageLabel;
      }
      if (r.elements?.length) {
        const seen = new Set(existing.elements.map((e) => e.key));
        for (const el of r.elements) {
          if (!seen.has(el.key)) {
            existing.elements.push(el);
            seen.add(el.key);
          }
        }
      }
    }
  }
  return Array.from(byKey.values()).sort((a, b) => a.label.localeCompare(b.label));
}

export const ACCESS_CONTROL_MANIFEST: ManifestPage[] = buildManifest();

export function findManifestPage(pageKey: string): ManifestPage | undefined {
  return ACCESS_CONTROL_MANIFEST.find((p) => p.pageKey === pageKey);
}
